module.exports = __webpack_public_path__ + "static/media/Front Right Tire.42ab6872.svg";